function itemHtml(ctx, it) {
    return `<div class="fq-acc"><button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}"><span class="fq-num" aria-hidden="true">${it.num}</span><span class="fq-q">${it.q}</span>${ctx.icon}</button><div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div></div>`;
}
const canopy = {
    id: 'canopy',
    name: 'Canopy',
    tag: 'Topic panels',
    styleTag: 'Structured & warm',
    description: 'Each topic gets its own bordered panel with a colored spine, numbered questions, and a quiet serif heading. Organize a growing FAQ into approachable sections.',
    layout: 'accordion',
    defaultAccent: '#587348',
    darkDefault: false,
    catSupport: 'required',
    features: ['accordion'],
    render(ctx) {
        return {
            html: `<div class="fq-wrap"><div class="fq-head"><h2 class="fq-title">${ctx.title}</h2>${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}</div><div class="fq-groups">${ctx.groups.map((g) => `<div class="fq-group">${g.name ? `<h3 class="fq-cat">${g.name}<span class="fq-total">${ctx.t(g.items.length === 1 ? 'questionsOne' : 'questionsMany', { count: g.items.length })}</span></h3>` : ''}<div class="fq-list">${g.items.map((it) => itemHtml(ctx, it)).join('')}</div></div>`).join('')}</div></div>`,
            css: `
.FQM .fq-wrap{max-width:820px;margin:0 auto;overflow-wrap:anywhere}
.FQM .fq-head{text-align:center;max-width:620px;margin:0 auto 32px}
.FQM .fq-title{margin:0 0 12px;font-family:${ctx.v.head};font-size:38px;font-weight:500;line-height:1.13;letter-spacing:-.015em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15.5px;line-height:1.65;color:${ctx.v.sub}}
.FQM .fq-groups{display:grid;gap:20px}
.FQM .fq-group{border:1px solid ${ctx.v.border};border-left:4px solid ${ctx.v.accent};border-radius:${ctx.v.radiusCard};background:${ctx.v.card};overflow:hidden}
.FQM .fq-cat{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;margin:0;padding:16px 24px;background:${ctx.v.soft};font-family:${ctx.v.head};font-size:22px;font-weight:550;color:${ctx.v.ink}}
.FQM .fq-total{font-family:${ctx.v.mono};font-size:10px;font-weight:400;color:${ctx.v.sub}}
.FQM .fq-list{padding:0 24px}
.FQM .fq-acc+.fq-acc{border-top:1px solid ${ctx.v.border}}
.FQM .fq-qbtn{display:flex;align-items:center;gap:16px;width:100%;padding:20px 0;color:${ctx.v.ink}}
.FQM .fq-num{flex:0 0 auto;font-family:${ctx.v.mono};font-size:11px;color:${ctx.v.sub}}
.FQM .fq-q{flex:1;font-size:16px;font-weight:550;line-height:1.5}
.FQM .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 0 22px 32px;font-size:15px;line-height:1.7;color:${ctx.v.sub}}
@media(max-width:480px){.FQM .fq-cat{padding:16px}.FQM .fq-list{padding:0 16px}.FQM .fq-qbtn{gap:12px}.FQM .fq-a{padding-left:0}}
`,
        };
    },
};
export default canopy;
